import React, { useEffect, useState } from 'react';
import { fetchSalesReportAP } from '../services/api';

/**
 * Reports > Sales Report (AP): the admin portal report, month by month (Azure exit WS8). Built
 * beside Sales Report because that page counts reships and VIP signups on purpose and this one
 * must match the admin portal to the cent. As there, the Total row counts reships and the days do
 * not, so it reads higher than the days added up.
 */

const money = (n) => `$${Number(n || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const monthNow = () => { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`; };
const showDate = (ymd) => `${ymd.slice(5, 7)}/${ymd.slice(8, 10)}/${ymd.slice(0, 4)}`;

export default function SalesReportAP() {
  const [month, setMonth] = useState(monthNow());
  const [rows, setRows] = useState(null);
  const [totals, setTotals] = useState({});
  const [error, setError] = useState(null);

  useEffect(() => {
    let live = true;
    setRows(null);
    setError(null);
    const [y, m] = month.split('-');
    fetchSalesReportAP(parseInt(m, 10), parseInt(y, 10))
      .then((r) => { if (live) { setRows(r.rows); setTotals(r.totals); } })
      .catch((e) => { if (live) setError(e.message); });
    return () => { live = false; };
  }, [month]);

  return (
    <div>
      <div className="page-header">
        <h2 style={{ fontSize: 16, fontWeight: 700, color: 'var(--navy)', margin: 0 }}>Sales Report (AP)</h2>
      </div>
      <div className="port-filters">
        <input type="month" className="form-input" style={{ width: 'auto' }} value={month} onChange={(e) => e.target.value && setMonth(e.target.value)} />
      </div>
      <div className="card">
        {error && <div style={{ padding: 16, fontSize: 12, color: 'var(--red)' }}>Error: {error}</div>}
        {!rows && !error && <div style={{ padding: 16, fontSize: 12, color: 'var(--gray-500)' }}>Loading...</div>}
        {rows && rows.length === 0 && <div style={{ padding: 16, fontSize: 12, color: 'var(--gray-500)' }}>No orders this month.</div>}
        {rows && rows.length > 0 && (
          <div className="port-scroll">
            <table className="trans-table">
              <thead>
                <tr><th>Date</th><th>Orders</th><th>Sales</th><th>VIP Orders</th><th>VIP Sales</th><th>New VIPs</th></tr>
              </thead>
              <tbody>
                {rows.map((r) => (
                  <tr key={r.orderDate}>
                    <td>{showDate(r.orderDate)}</td>
                    <td>{r.orderCount}</td>
                    <td>{money(r.totalSum)}</td>
                    <td>{r.vipOrderCount}</td>
                    <td>{money(r.vipTotalSum)}</td>
                    <td>{r.newVIPOrderCount}</td>
                  </tr>
                ))}
                <tr style={{ fontWeight: 700 }}>
                  <td>Total</td>
                  <td>{totals.orderCount}</td>
                  <td>{money(totals.totalSum)}</td>
                  <td>{totals.vipOrderCount}</td>
                  <td>{money(totals.vipTotalSum)}</td>
                  <td />
                </tr>
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}